import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import Affectation from '../Classes/ClvrAffectation'
import { AffectationDto } from '../Types/AffectationDto'
import { BedApiAdapter } from './BedApiAdapter'
import { ServiceApiAdapter } from './ServiceApiAdapter'

export class AffectationApiAdapter implements ApiDataAdapter<Affectation> {
    public createClass(apiData: AffectationDto): Affectation {
        const service = get(apiData, '_ref_service')
        const bed = get(apiData, '_ref_lit')

        const affectation: Affectation = new Affectation({
            id: get(apiData, 'affectation_id'),
            serviceId: get(apiData, 'service_id'),
            bedId: get(apiData, 'lit_id'),
        })

        if (service) {
            affectation.service = new ServiceApiAdapter().createClass(service)
        }
        if (bed) {
            affectation.bed = new BedApiAdapter().createClass(bed)
        }

        return affectation
    }
}
